import { gql } from '@apollo/client';

export const GET_REACTION_INFORMATION = gql`
    query getReactionInformation($collectionName: String!, $docId: String!) {
        getReactionInformation(input: { collectionName: $collectionName, docId: $docId }) {
            reactionState {
                isAlreadyLike
                isAlreadyDislike
            }
            reactionNumber {
                totalLike
                totalDislike
            }
        }
    }
`;
